import React from 'react';
import { useNavigate } from 'react-router-dom';
import './won.css';

const Won = ({ onReplay, chooseRoomPath = '/levels2' }) => {
  const navigate = useNavigate();

  return (
    <div className="wonoverlay">
      <div className="wondiv1">

        <div className="wonstars">✦ ✦ ✦</div>

        <h1 className="wontitle">
          YOU SOLVED THE MYSTERY
        </h1>

        <p className="wonsubtitle">
          The hotel couldn't hold you.
        </p>

        <div className="wonline" />

        <div className="wonbtns">
          <button
            className="playagainn"
            onClick={onReplay}
          >
            Play Again
          </button>

          <button
            className="wonbtlevels"
            onClick={() => navigate(chooseRoomPath)}
          >
            Choose Room
          </button>

          <button
            className="wonbtlevels"
            onClick={() => navigate('/start')}
          >
            Main Menu
          </button>
        </div>

      </div>
    </div>
  );
};

export default Won;